export const POS_AI_MANAGER_ENABLED_KEY = "pos_ai_manager_enabled";
export const POS_AI_MANAGER_PREFERENCE_EVENT = "pos-ai-manager-preference-changed";

export const readAiManagerPreference = (storage = localStorage) =>
  storage.getItem(POS_AI_MANAGER_ENABLED_KEY) === "true";

export const writeAiManagerPreference = (enabled, storage = localStorage) => {
  storage.setItem(POS_AI_MANAGER_ENABLED_KEY, enabled ? "true" : "false");
  if (typeof window !== "undefined") {
    window.dispatchEvent(new Event(POS_AI_MANAGER_PREFERENCE_EVENT));
  }
};
